import { setsAnalysisPhasesTritioVapor } from "@app/pages/samples/config/phases/AnalysisPhases";
import useTabs from "@app/pages/samples/utils/useTab";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useDefaultValuesData } from "../../utils/useDefaultValuesData";
import { getDefaultValuesTritioVapor } from "./getDefaultValues";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";

const TritioVapor = () => {
  const { tabValueAnalysis } = useTabs();
  const { idMuestra } = useParams();
  const { currentCounting } = useAnalysis();

  const form = useFormContext();
  const typeAnalysis = form.watch("typeAnalysis");
  const defaultPreloadValues = useDefaultValuesData(
    typeAnalysis,
    form.getValues("processing_date_time_end")
  );
  const currentPreparationObject = defaultPreloadValues.currentPreparationIndex;

  useEffect(() => {
    if (currentPreparationObject) {
      const currentValues = form.getValues();

      const newValues = {
        ...currentValues,
        ...getDefaultValuesTritioVapor(defaultPreloadValues),
      };

      form.reset(newValues);
    }
  }, [idMuestra, JSON.stringify(currentPreparationObject), currentCounting]);

  const CurrentComponent =
    setsAnalysisPhasesTritioVapor[tabValueAnalysis].component;
  return (
    <CurrentComponent
      key={`tab-${defaultPreloadValues.currentPreparation.index}-${defaultPreloadValues.currentPreparation.id}`}
    />
  );
};

export default TritioVapor;
